import React from 'react';
import { ComponentSkinProps } from '../../../../types/component-skin';
import { TrendingItem } from '../TrendingItems.types';
import '../TrendingItems.css';

// SafeImage 컴포넌트 - 원본 컴포넌트와 동일하게 구현
interface SafeImageProps {
  src: string;
  alt: string;
  style?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
}

const SafeImage: React.FC<SafeImageProps> = ({ src, alt, style, containerStyle }) => {
  return (
    <div className="safe-image-container" style={containerStyle}>
      <img src={src} alt={alt} style={style} />
    </div>
  );
};

/**
 * TrendingItems 기본 스킨
 */
const BasicTrendingItemsSkin: React.FC<ComponentSkinProps> = ({ 
  data, 
  actions, 
  options, 
  mode, 
  utils,
  app,
  editor
}) => {
  // data에서 필요한 값 추출 - className을 여러 경로에서 시도
  const {
    id,
    style: dataStyle,
    className: dataClassName,
    title,
    subtitle,
    imageRadius,
    showMoreButton,
    moreButtonText,
    moreButtonUrl,
    moreButtonStyle,
    items = [],
    hasValidMoreUrl
  } = data;
  
  // 여러 경로에서 className과 style 추출
  const propsClassName = data.props?.className || '';
  const directClassName = dataClassName || '';
  const componentPropsClassName = data.componentProps?.className || '';
  
  // 모든 className 소스 합치기
  const className = [propsClassName, directClassName, componentPropsClassName]
    .filter(Boolean)
    .join(' ');
  
  const style = data.props?.style || dataStyle || {};
  
  
  // actions에서 필요한 함수 추출
  const {
    handleItemClick,
    handleMoreButtonClick,
    handleItemHover,
    handleMoreButtonHover,
    isValidUrl,
    translate
  } = actions;
  
  // 아이템 렌더링 함수
  const renderItems = () => {
    return (items || []).map((item: TrendingItem, index: number) => {
      const hasValidUrl = isValidUrl(item.url);
      const translatedTitle = typeof item.title === 'string' ? translate(item.title) : item.title;
      
      // 아이템 내용
      const itemContent = (
        <>
          <div 
            className="trending-item-image-container" 
            style={{ borderRadius: imageRadius }}
          >
            <SafeImage 
              src={item.image} 
              alt={translatedTitle}
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'cover',
                borderRadius: imageRadius
              }}
              containerStyle={{ 
                width: '100%', 
                aspectRatio: '1/1',
                borderRadius: imageRadius
              }}
            />
          </div>
          <div className="trending-item-content">
            <h3 className="trending-item-title">{translatedTitle}</h3>
          </div>
        </>
      );
      
      return (
        <div 
          key={item.id || index} 
          className="trending-item"
          onMouseEnter={() => handleItemHover(item.id || index)}
          onMouseLeave={() => handleItemHover(null)}
        >
          {hasValidUrl ? (
            <a 
              href={item.url} 
              className="trending-item-link"
              onClick={(e) => handleItemClick(item, e)}
            >
              {itemContent}
            </a>
          ) : (
            <div 
              className="trending-item-link"
              onClick={(e) => handleItemClick(item, e)}
            >
              {itemContent}
            </div>
          )}
        </div>
      );
    });
  };
  
  return (
    <div id={id} className={className} style={style}>
      <div className="trending-items-header">
        <div className="trending-items-subtitle">{subtitle}</div>
        <h2 className="trending-items-title">{title}</h2>
      </div>
      <div className="trending-items-container">
        {renderItems()}
      </div>
      
      {/* MORE 버튼 */}
      {showMoreButton && (
        <div className="trending-items-more-button-container">
          {hasValidMoreUrl ? (
            <a 
              href={moreButtonUrl} 
              className="trending-items-more-button"
              style={moreButtonStyle}
              onClick={handleMoreButtonClick}
              onMouseEnter={() => handleMoreButtonHover(true)}
              onMouseLeave={() => handleMoreButtonHover(false)}
            >
              {moreButtonText}
            </a>
          ) : (
            <button 
              className="trending-items-more-button"
              style={moreButtonStyle}
              onClick={handleMoreButtonClick}
              onMouseEnter={() => handleMoreButtonHover(true)}
              onMouseLeave={() => handleMoreButtonHover(false)}
            >
              {moreButtonText}
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default BasicTrendingItemsSkin;